import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Utils
import { validateEmail } from '../../helpers/utils';

// Actions
import { gameActions } from '../../actions';

import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Header from '../../components/Header';
import Reopen from '../../components/Reopen';
import List from '../../components/List';
import AddPlayer from './add_player';

const statusLabels = {
  init: 'Ongoing',
  deal: 'Submitted',
  nodeal: 'Abandoned',
};

const Players = () => {
  // Hooks
  const dispatch = useDispatch();
  const user = useSelector((state) => state.authentication.user);
  const game = useSelector((state) => state.game);
  const { id } = useParams();
  // const player = useSelector(state => state.player);

  // const [item, setItem] = useState(game || null);
  const [pairModal, setPairModal] = useState(false);
  const [newPlayers, setNewPlayers] = useState([]);

  useEffect(() => {
    if (id) {
      dispatch(gameActions.fetchGames(id));
    }
  }, [dispatch, id]);

  // useEffect(() => {
  //   setItem(game);
  // }, [game]);

  const addPairModal = () => {
    setPairModal(!pairModal);
    setNewPlayers([]);
  };

  const handleNewPlayers = (players) => {
    setNewPlayers(players);
  };

  const submitNewPlayers = () => {
    dispatch(gameActions.addPlayers(game.data._id, newPlayers));
    addPairModal();
    setNewPlayers([]);
  };

  let players = game.data?.players || [];

  players = players.map((p, pi) => {
    const pres = game.data
      ? game.data.results.find((r) => r.player_id === p._id)
      : null;
    p.count = p.results.length;
    p.role = p.rindex === 0 ? "Federico's" : 'Zephyr';
    const ml =
      process.env.REACT_APP_GAME_URL +
      '?i=' +
      p.game_id +
      '&e=' +
      p.email +
      '&t=' +
      p.token +
      '&k=1';
    p.status = p ? (
      <>
        {game?.round !== null && (
          <>
            {!pres ? (
              <span>Closed</span>
            ) : (
              <span>{statusLabels[pres ? 'deal' : 'init']}</span>
            )}
          </>
        )}

        {game?.round === null && (
          <>
            <span>{statusLabels[pres ? 'deal' : 'init']}</span>
            {pres && (
              <>
                <Reopen game={game.data._id} player={p._id} />
              </>
            )}
          </>
        )}
      </>
    ) : (
      ''
    );
    p.magiclink =
      user.from !== 'lti-hbp' ? (
        <a href={ml} target='_blank' rel='noreferrer'>
          <code style={{ maxWidth: '100px' }}>{ml}</code>
        </a>
      ) : (
        'N/A'
      );
    return p;
  });

  const validNewPlayers =
    newPlayers.length === 0
      ? false
      : newPlayers.every((pl) => validateEmail(pl.email));

  const repeatedPlayers = newPlayers.filter((pl, pli) => {
    return (
      players.find((p) => p.email === pl.email) ||
      newPlayers.find((p, pi) => p.email === pl.email && pli !== pi)
    );
  });

  return (
    <div>
      <Header />

      <h2 className='d-flex flex-column flex-md-row mt-3 sec-title fs-3'>
        <span>
          Player Management{' '}
          <small
            className='badge badge-pill text-bg-success ms-3'
            style={{
              fontSize: '12px',
              padding: '5px 8px',
              verticalAlign: 'middle',
            }}>
            {players.length} players
          </small>
        </span>

        {user.from !== 'lti-hbp' && (
          <small className='mt-3 mt-md-0 ms-0 ms-md-auto'>
            <button className='btn btn-outline-primary' onClick={addPairModal}>
              Add Player
            </button>
            <button
              className='btn btn-outline-primary ms-3'
              onClick={(e) => window.location.reload()}>
              <FontAwesomeIcon icon='redo-alt' className='me-1' size='sm' />{' '}
              Refresh
            </button>
          </small>
        )}
      </h2>

      <div className='mt-3'>
        <List
          labels={['Name', 'Surname', 'Email', 'Status', 'MagicLink']}
          fields={['name', 'lastname', 'email', 'status', 'magiclink']}
          data={players}
        />
      </div>

      <Modal
        isOpen={pairModal}
        toggle={addPairModal}
        centered={true}
        size={'lg'}>
        <ModalHeader>Add Player</ModalHeader>
        <ModalBody className='text-center'>
          <p>
            Enter the player information and click the <b>"Add"</b> button.
          </p>
          <AddPlayer
            onChange={handleNewPlayers}
            roles={["Federico's", 'Zephyr']}
          />
          {repeatedPlayers.length > 0 && (
            <div className='alert alert-danger mt-4'>
              The following players are already in this session:{' '}
              <b>{repeatedPlayers.map((p) => p.email).join(', ')}</b>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <button className='btn btn-light' onClick={addPairModal}>
            Cancel
          </button>
          <button
            className='btn btn-outline-primary'
            onClick={submitNewPlayers}
            disabled={!validNewPlayers || repeatedPlayers.length > 0}>
            Add
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export const GamePlayers = Players;
